<template>
  <div class="todo-container">
  <v-layout row wrap>
      <div class="todo-item" :class="{'checked': checked, 'no-action': !action}">
        <div class="todo-checkbox" @click="toggle">
          <i class="material-icons">{{ icon }}</i>
        </div>
        <div class="todo-label" @click="clickLabel">{{ label }}</div>
      </div>
  </v-layout>
  <v-layout v-if="!checked">
    <div class="todo-instructions" v-html="message"></div>
  </v-layout>
  <v-layout row wrap v-if="showAction">
    <v-flex justify-start>
      <div class="todo-action float-left" v-if="action">
        <component :assignment="assignment" :is="action" ref="childAction" v-on:clicked="clickLabel"></component>
      </div>
    </v-flex>
    <v-flex v-if="reportReasons" justify="end">
      <div class="todo-action float-right">
        <report-an-issue :assignment="assignment" :reportReasons="reportReasons"></report-an-issue>
      </div>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import Back from "@/modules/Back";
import Bus from "../../modules/Bus";
import DownloadManuscript from "./Actions/DownloadManuscript";
import ViewOnAmazon from "./Actions/ViewOnAmazon";
import PostOnAmazon from './Actions/PostOnAmazon.vue';
import TurnInReview from "./Actions/TurnInReview";
import ReportAnIssue from './Actions/ReportAnIssue';

export default {
  name: "TodoItem",
  props: ["id", "checked", "label", "action", "report", "reportReasons", "assignment", "message"],
  emits:["toggle-checked"],
  components: {
    "download-manuscript": DownloadManuscript,
    "view-on-amazon": ViewOnAmazon,
    "post-on-amazon": PostOnAmazon,
    "turn-in-review": TurnInReview,
    "report-an-issue" : ReportAnIssue,
  },
  computed: {
    icon() {
      return this.checked ? "check_box" : "check_box_outline_blank";
    },
    showAction() {
      if (this.action === 'turn-in-review') {
        return this.assignment.status === 'Assigned'
      }
      return !this.checked
    }
  },
  methods: {
    clickLabel() {
      this.toggle();
      // if (this.checked) {
      //   let that = this;

      //   if (this.id !== 6) {
      //     that.$refs.childAction.handleClick();
      //   }
      // }
    },
    toggle() {
      if (this.id === 4) {
        this.$refs.childAction.handleClick();
        return;
      }

      // this.checked = !this.checked;

      this.$emit("toggle-checked", {
        id: this.id,
        checked: !this.checked
      })

      if (!this.assignment.todos) {
        this.assignment.todos = {};
      }

      this.assignment.todos[this.id] = !this.checked;
      Back.saveAssignment(this.assignment);
    }
  }
};
</script>

<style lang="scss" scoped>

.todo-container {
  margin: 18px 0px;
}

.extra-instructions {
  float:inline-start;
  color: #777;
  font-size: 13pt;
  padding: 0 34px;
}

.todo-item {
  display: inline-flex;
  // height: 32px;
  margin: 0px 0 4px 0;
  font-size: 13pt;
  line-height: 1.2em;
}
.todo-checkbox {
  // float: left;
  width: 34px;
  padding: 4px;
  padding-top: 1px;
  font-size: 24pt;
  color: #7e57c2;
  transition: all 0.2s ease-in-out;
}
.todo-label {
  // float: left;
  // width: 260px;
  font-weight: 600;
  padding-top: 0px;
  font-size: 15pt;
  line-height: 1.2em;
}
.todo-action {
  margin-top: 1.5em;
}

.float-left {
  float: left;
  margin-left: 3em;
}

.float-right {
  float: right;
  margin-right: 3em;
}

.todo-instructions {
  margin-left: 2.2em;
  font-size: 12pt;
}

.todo-item:hover {
  .todo-checkbox {
    color: darken(#7e57c2, 12%);
    cursor: pointer;
    transform: scale(1.1);
  }
  .todo-label {
    color: #777;
    cursor: pointer;
  }
}

.checked {
  .todo-checkbox {
  }
  .todo-label {
    color: #999;
    text-decoration: line-through;
  }
  .todo-action {
    opacity: 1;
  }
}

@media (max-width: 1024px) {
  .todo-item {
    height: 62px;
  }

  .todo-action {
    width: auto !important;
    float: none !important;
    display: block !important;
    text-align: left;
    margin-top: 9px;
    margin-left: 38px;
    zoom: 0.9;
  }

  .todo-label {
    padding-top: 2px;
    width: 250px;
    font-size: 13pt;
  }

  .no-action {
    height: 24px !important;
  }
}
</style>

